module.exports = __webpack_public_path__ + "img/worldmap_ufo_pic.df23e738.png";